export interface ProductLine {
  id: number;
  lineName: string;
  desc: string;
  simpleName: string;
  fullName: string;
  priority: ProductLinePriorityEnum;
}

export enum ProductLinePriorityEnum {
  P1 = 1,
  P2 = 2,
  P3 = 3,
}

export const ProductLinePriorityEnumMap = [
  {
    label: 'P1',
    value: ProductLinePriorityEnum.P1,
    color: 'red',
  },
  {
    label: 'P2',
    value: ProductLinePriorityEnum.P2,
    color: 'blue',
  },
  {
    label: 'P3',
    value: ProductLinePriorityEnum.P3,
    color: 'green',
  },
];

export interface ProductSeries {
  id: number;
  seriesName: string;
  desc: string;
  enable: number;
  productLineId: number;
  lineName: string;
}

export enum ProductSeriesEnableEnum {
  Enable = 1,
  Disable = 2,
}

export const ProductSeriesEnableEnumMap = [
  {
    label: '有效',
    value: ProductSeriesEnableEnum.Enable,
    color: 'green',
  },
  {
    label: '无效',
    value: ProductSeriesEnableEnum.Disable,
    color: 'red',
  },
];

export interface SysProject {
  [x: string]: any;
  id: number;
  name: string;
  desc: string;
  dingWebhook: string;
  jiraProjectId: string;
  jiraProjectName: string;
  phase: SysProjectPhases;
  priority: number;
  difficulty?: number; // 项目难度，可选字段
  isConfidential?: number; // 保密级别：0=公开 1=保密(仅成员可见)，仅 admin 可改
  productSeriesId: number;
  status: SysProjectStatus;
  type: SysProjectType;
  createBy: number;
  createdAt: number;
  updateBy: number;
  updatedAt: number;
  phaseName: string;
  seriesName: string;
  pkey: string;
  code: string;
}

export enum SysProjectType {
  Software = 1, // 软件
  Hardware = 2, // 硬件
}

export const SysProjectTypeMap = [
  {
    label: '软件',
    value: SysProjectType.Software,
    color: 'blue',
  },
  {
    label: '硬件',
    value: SysProjectType.Hardware,
    color: 'orange',
  },
];

export enum SysProjectConfidential {
  Public = 0, // 公开
  Confidential = 1, // 保密(仅成员可见)
}

export const SysProjectConfidentialMap = [
  {
    label: '公开',
    value: SysProjectConfidential.Public,
    color: 'green',
  },
  {
    label: '保密',
    value: SysProjectConfidential.Confidential,
    color: 'red',
  },
];

export enum SysProjectStatus {
  Running = 3, // 在研
  Maintenance = 4, // 维护
  Closure = 5, // 结项
}

export const SysProjectStatusMap = [
  {
    label: '在研',
    value: SysProjectStatus.Running,
    color: 'green',
  },
  {
    label: '维护',
    value: SysProjectStatus.Maintenance,
    color: 'blue',
  },
  {
    label: '结项',
    value: SysProjectStatus.Closure,
    color: 'red',
  },
];

export enum SysProjectPhases {
  EngineeringPrototypes = 9,
  TrialProduce = 10,
  SmallBatchProduce = 11,
  BatchProduce = 12,
  ConceptProduce = 13,
  PreResearchProduce = 14,
  PlanningProduce = 15,
}

export const SysProjectPhasesMap = [
  {
    label: '概念阶段',
    value: SysProjectPhases.ConceptProduce,
    color: '#f50',
    node: '概念阶段',
    nodeId: 13,
  },
  {
    label: '预研阶段',
    value: SysProjectPhases.PreResearchProduce,
    color: '#f50',
    node: '预研阶段',
    nodeId: 14,
  },
  {
    label: '计划阶段',
    value: SysProjectPhases.PlanningProduce,
    color: '#f50',
    node: '计划阶段',
    nodeId: 15,
  },
  {
    label: '工程样机阶段',
    value: SysProjectPhases.EngineeringPrototypes,
    color: '#f50',
    node: 'ES',
    nodeId: 9,
  },
  {
    label: '试产阶段',
    value: SysProjectPhases.TrialProduce,
    color: '#2db7f5',
    node: 'PR',
    nodeId: 10,
  },
  {
    label: '小批量阶段',
    value: SysProjectPhases.SmallBatchProduce,
    color: '#87d068',
    node: 'PP',
    nodeId: 11,
  },
  {
    label: '量产阶段',
    value: SysProjectPhases.BatchProduce,
    color: '#108ee9',
    node: 'MP',
    nodeId: 12,
  },
];

export enum SysProjectPriority {
  P1 = 6,
  P2 = 7,
  P3 = 8,
}

export const SysProjectPriorityMap = [
  {
    label: 'P1',
    value: SysProjectPriority.P1,
    color: 'red',
  },
  {
    label: 'P2',
    value: SysProjectPriority.P2,
    color: 'blue',
  },
  {
    label: 'P3',
    value: SysProjectPriority.P3,
    color: 'green',
  },
];

export enum SysProjectDifficulty {
  Level1 = 1,
  Level2 = 2,
  Level3 = 3,
  Level4 = 4,
}

export const SysProjectDifficultyMap = [
  {
    label: '1级',
    value: SysProjectDifficulty.Level1,
    color: 'red',
  },
  {
    label: '2级',
    value: SysProjectDifficulty.Level2,
    color: 'orange',
  },
  {
    label: '3级',
    value: SysProjectDifficulty.Level3,
    color: 'blue',
  },
  {
    label: '4级',
    value: SysProjectDifficulty.Level4,
    color: 'green',
  },
];
